<template>
  <el-container v-if="productId">
    <el-header>
      <div>
        <span class="item-no">货号：{{ itemNo }}</span>
        <span>
          SKU数量：<strong>{{ skuCount }}</strong>
        </span>
        <span>
          当前库存：<strong>{{ stock }}</strong>
        </span>
        <span>
          占用库存：<strong>{{ occupyStock }}</strong>
        </span>
        <span>
          可用库存：<strong>{{ leftStock }}</strong>
        </span>
      </div>
      <div>
        <el-button type="primary" plain :loading="actionLoading" @click="onCopy">复制库存</el-button>
        <el-button type="primary" plain :loading="actionLoading" @click="onScreenShot">库存截图</el-button>
        <el-button v-if="multiWarehouse" type="default" plain @click="onExpandToggle">
          全部{{ isExpand ? '折叠' : '展开' }}
          <i :class="isExpand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </el-button>
      </div>
    </el-header>
    <el-main>
      <el-table
        :key="tableKey"
        :data="tableData"
        :span-method="objectSpanMethod"
        v-loading="loading"
        header-row-class-name="table-header"
        border
        height="100%"
        :row-class-name="handleRowClass"
      >
        <el-table-column
          :label="'颜色' + (multiWarehouse ? '' : ' \ 尺码')"
          header-align="center"
          align="center"
          fixed
          width="140"
          class-name="color"
        >
          <template slot-scope="{ row }">
            {{ row.Color }}
            <i
              v-if="multiWarehouse"
              :class="row.IsExpand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
              @click="onColorExpandToggle(row.Color)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column v-if="multiWarehouse" label="仓库 \ 尺码" prop="WName" header-align="center" align="center" fixed width="100">
        </el-table-column>
        <el-table-column
          v-for="(size, index) in sizeColumns"
          :key="index"
          :label="size.label"
          header-align="center"
          align="center"
          width="130"
        >
          <template slot-scope="{ row }">
            <div v-if="row[size.prop].SpecID > 0" class="stock">
              {{ row[size.prop].Stock }}
              <el-popover
                v-if="row[size.prop].SpecID > 0 && (!multiWarehouse || row.WID > -1)"
                placement="top"
                title="修改库存"
                trigger="click"
                popper-class="edit-stock"
              >
                <i class="el-icon-edit-outline" slot="reference"></i>
                <template>
                  <el-form inline>
                    <el-form-item :label="row.Color + '-' + size.label + '：'">
                      <el-input v-model.number="editStock"></el-input>
                      <el-button
                        type="primary"
                        :loading="actionLoading"
                        @click="onStockEdit(row[size.prop].SpecID, row.WID, row[size.prop].Stock)"
                        >确定</el-button
                      >
                    </el-form-item>
                  </el-form>
                </template>
              </el-popover>
            </div>
            <div v-if="row[size.prop].SpecID > 0" class="other-stock">
              <span>占 {{ row[size.prop].OccupyStock }}</span>
              <span>余 {{ row[size.prop].LeftStock }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label=""></el-table-column>
      </el-table>
      <div id="screenshot" v-if="isScreenShot">
        <el-table :data="screenshotData" header-row-class-name="table-header" border height="100%">
          <el-table-column key="color" label="颜色 \ 尺码" prop="Color" header-align="center" align="center" width="130"></el-table-column>
          <el-table-column
            v-for="(size, index) in sizeColumns"
            :key="size + '-' + index"
            :label="size.label"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="{ row }">{{ row[size.prop].LeftStock > 0 ? row[size.prop].LeftStock : 0 }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
  </el-container>
  <div v-else class="empty-tip">点击商品查看规格库存</div>
</template>

<script>
import { submit } from '@/api/base'
import clipboard from '@/utils/clipboard'
import { screenshotToBase64, copyImage } from '@/utils/stallBot'

export default {
  name: 'StockDetail',
  props: {
    productId: Number,
  },
  watch: {
    productId(newValue, oldValue) {
      this.fetchStockDetail()
    },
  },
  data() {
    return {
      loading: false,
      tableKey: '',
      itemNo: '',
      skuCount: 0,
      stock: 0,
      occupyStock: 0,
      leftStock: 0,
      multiWarehouse: false,
      isExpand: false,
      sizeColumns: [],
      tableData: [],
      screenshotData: [],
      actionLoading: false,
      isScreenShot: false,
      editStock: '',
    }
  },
  methods: {
    async fetchStockDetail(initColumn = true) {
      this.clearData(initColumn)
      if (this.productId) {
        this.loading = true
        const res = await submit('/api/wms/stock/getDetails', { ProductID: this.productId })
        this.loading = false
        if (res.data) {
          this.itemNo = res.data.ItemNo
          this.skuCount = res.data.SkuCount
          this.stock = res.data.Stock
          this.occupyStock = res.data.OccupyStock
          this.leftStock = res.data.LeftStock
          this.multiWarehouse = res.data.MultiWarehouse
          if (initColumn) {
            this.sizeColumns = (res.data.Sizes || []).map(item => ({ label: item.substring(item.indexOf('-') + 1), prop: item }))
          }
          let specs = res.data.Specs || []
          specs.forEach(item => (item.IsExpand = false))
          this.tableData = specs
          let curColor = ''
          this.tableData.forEach(row => {
            if (curColor != row.Color) {
              curColor = row.Color
              this.screenshotData.push(row)
            }
          })
          this.tableKey = Math.random()
        }
      }
    },
    clearData(initColumn) {
      this.itemNo = ''
      this.skuCount = 0
      this.stock = 0
      this.occupyStock = 0
      this.leftStock = 0
      this.multiWarehouse = false
      this.isExpand = false
      if (initColumn) {
        this.sizeColumns = []
      }
      this.tableData = []
      this.screenshotData = []
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0 && row.IsExpand) {
        let rowspan = 1
        if (rowIndex == 0 || this.tableData[rowIndex - 1].Color != row.Color) {
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].Color == row.Color) {
              rowspan++
            } else {
              break
            }
          }
          return { rowspan, colspan: 1 }
        } else {
          return { rowspan: 0, colspan: 0 }
        }
      }
      return { rowspan: 1, colspan: 1 }
    },
    onCopy(e) {
      this.actionLoading = true
      let text = '货号：' + this.itemNo + '  总库存：' + (this.leftStock > 0 ? this.leftStock : 0) + '\r\n'
      for (const item of this.screenshotData) {
        let i = 0
        for (const size of this.sizeColumns) {
          if (i++ == 0) {
            text += item.Color
          } else {
            for (let j = 0; j < item.Color.length; j++) {
              text += '    '
            }
          }
          text += '  ' + size.label + '  库存：' + (item[size.prop].LeftStock > 0 ? item[size.prop].LeftStock : 0) + '\r\n'
        }
      }
      try {
        clipboard(text, e)
      } finally {
        this.actionLoading = false
      }
    },
    async onScreenShot() {
      this.actionLoading = true
      this.isScreenShot = true
      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 50))
      try {
        let style = '<style>'
        style += 'table {'
        style += 'border-collapse: collapse;'
        style += '}'
        style += 'th, td {'
        style += 'border: 1px solid #ebeef5;'
        style += 'text-align: center;'
        style += 'padding: 5px 0;'
        style += '}'
        style += 'th {'
        style += 'background: #f3f7f9;'
        style += ' }'
        style += '</style>'
        let $div = this.$('#screenshot')
        $div.append(style)
        let dataUrl = await screenshotToBase64($div.get(0))
        await copyImage(dataUrl)
      } finally {
        this.actionLoading = false
        this.isScreenShot = false
      }
    },
    onExpandToggle() {
      this.isExpand = !this.isExpand
      this.tableData.forEach(row => this.$set(row, 'IsExpand', this.isExpand))
    },
    onColorExpandToggle(color) {
      this.tableData.forEach(row => {
        if (row.Color == color) {
          this.$set(row, 'IsExpand', !row.IsExpand)
        }
      })
    },
    handleRowClass({ row }) {
      if (this.multiWarehouse) {
        if (row.WID != -1 && !row.IsExpand) {
          return 'fold'
        }
        if (row.WID == -1 && row.IsExpand) {
          return 'expand'
        }
      }
      return ''
    },
    async onStockEdit(specId, wid, oldStock) {
      let editStock = parseInt(this.editStock) || 0
      if (editStock >= 0 && editStock != oldStock) {
        this.actionLoading = true
        try {
          const res = await submit('/api/wms/stock/adjust', {
            ProductID: this.productId,
            SpecID: specId,
            WID: wid,
            Stock: editStock,
          })
          if (!res.success) {
            this.$message.error(res.msg || '修改失败')
          } else {
            this.$message.success('修改成功')
            this.fetchStockDetail(false)
            this.$emit('refresh')
          }
        } finally {
          this.actionLoading = false
        }
      }
      this.editStock = ''
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-header {
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding: 2px 0 7px !important;

  > div:first-child span {
    margin-right: 25px;

    &.item-no {
      font-size: 18px;
      font-weight: 600;
    }
  }
}

::v-deep .el-table__row {
  &.fold {
    display: none;
  }

  &.expand .el-table__cell:not(.color) {
    background: #e0efff;
  }
}

::v-deep .el-table__cell {
  padding-top: 5px;

  &.color {
    position: relative;

    i {
      position: absolute;
      top: 50%;
      right: 10px;
      margin-top: -11px;
      font-size: 16px;
      color: #818181;
      z-index: 999;
      cursor: pointer;
    }
  }

  .cell {
    color: #333 !important;
  }
}

.stock {
  font-size: 16px !important;
  font-weight: 600;
  color: #333 !important;

  i {
    margin-left: 3px;
    color: #818181;
    cursor: pointer;
  }
}

.other-stock {
  background: #f5f6f7;
  border-radius: 4px;
  font-size: 12px;
  color: #818181;

  span:first-child {
    margin-right: 8px;
  }
}

#screenshot {
  position: fixed;
  top: 0;
  left: -9999px;
  background: #fff;
}

.empty-tip {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
  color: #ccc;
}
</style>

<style lang="scss">
.edit-stock {
  width: auto;
  padding-right: 0;

  .el-form-item__label {
    padding-right: 0;
  }

  .el-input {
    width: 100px;
    margin-right: 10px;
  }
}
</style>
